import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  loader: {
    padding: 4,
    marginLeft: 6
  },
  revertDecisionButton: {
    padding: 4,
    marginLeft: 6,
    transform: "rotateY(180deg)"
  }
});
